module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination"
  }, [_c('banner', {
    attrs: {
      "clazz": "purchase-coordination-banner",
      "url": "purchaseCoordination"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goMore('caigouxietong-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "purchase-coordination-section1"
  }, [_c('div', {
    staticClass: "section1-region"
  }, [_c('h1', {
    staticClass: "section1-title"
  }, [_vm._v("统一智能化采购协同平台")]), _vm._v(" "), _c('div', {
    staticClass: "section1-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-content"
  }, [_c('p', {
    staticClass: "content-describe"
  }, [_vm._v("供需双方需求在线可视化，实现按需生产，按需发货，自动对账补货提醒等全流程智能管理，缩短采购周期，满足采购急需，降低库存积压")]), _vm._v(" "), _c('ul', {
    staticClass: "content-detail clearfix"
  }, _vm._l((_vm.section1Data), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "content-img fl"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.src),
        expression: "item.src"
      }],
      staticClass: "detail-img",
      attrs: {
        "alt": "统一智能化采购协同平台"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "detail-content"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])])
  }), 0)]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "text": "了解更多",
      "clazz": "consult-button dib",
      "duration": 0.5
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goMore('caigouxietong-pingtai-liaojiegengduo')
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination-section2"
  }, [_c('div', {
    staticClass: "section2-content"
  }, [_c('h1', {
    staticClass: "section2-title"
  }, [_vm._v("预测需求，动态掌握供应商备库情况，合理安排排产计划")]), _vm._v(" "), _c('div', {
    staticClass: "section2-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section2-main"
  }, [_c('p', {
    staticClass: "section2-detail"
  }, [_vm._v("采购企业根据公司生产需求，预测所需物料，制定备货及送货计划，通过SRM系统下发至各供应商，")]), _vm._v(" "), _c('p', {
    staticClass: "section2-detail"
  }, [_vm._v("经由供应商反馈物料交期，智能分析报表数据，合理安排排产计划，全程在线实现，避免时间空档，提升生产效率")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination-section3"
  }, [_c('div', {
    staticClass: "section3-region"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("采购订单协同，智能提醒，一键触达")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-content"
  }, [_c('p', {
    staticClass: "content-describe"
  }, [_vm._v("颠覆传统线下电话/qq/传真等重复低效沟通方式，自动生成订单，消息全方位实时触达供应商，")]), _vm._v(" "), _c('p', {
    staticClass: "content-describe"
  }, [_vm._v("智能提醒订单的变更，退货")]), _vm._v(" "), _c('ul', {
    staticClass: "content-detail clearfix"
  }, [_c('li', {
    staticClass: "content-left fl"
  }, [_c('img', {
    staticClass: "section3-img-left fr",
    attrs: {
      "src": require("../../assets/img/purchaseCoordination/peitu1-2.png"),
      "alt": "采购订单协同"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "content-right fl"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("订单自动创建及发布：与ERP对接，实时同步\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("消息预警：短信&邮件&系统消息全方位及时通知供应商\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("在线确认：订单在线发布与确认，简洁高效\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("版本控制：采购订单版本变更，通知供应商\n              ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination-section3 purchase-coordination-section3-2"
  }, [_c('div', {
    staticClass: "section3-region"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("规范送货流程、缩短供货周期、降低库存积压")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-content"
  }, [_c('p', {
    staticClass: "content-describe"
  }, [_vm._v("送货过程规范化，紧急物资可追踪，集成条码系统实现扫码入库，合理优化库存管理，实现高效管理送货全流程")]), _vm._v(" "), _c('ul', {
    staticClass: "content-detail clearfix section3-under"
  }, [_c('li', {
    staticClass: "content-right fl"
  }, [_c('div', {
    staticClass: "under-conter-left fr"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("基于订单内容创建送货单，格式统一，快捷方便\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("查看收货看板，采购方可提前获知供应商送货计划，便于接收准备\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("紧急物资：对接物流API，小时级物流进度追踪\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("基于送货单接收，与条码系统集成，实现扫码接收入库；装箱单、"), _c('br'), _vm._v("\n                      送货单打印，便于接收盘点\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v(" 基于交货日期可以控制供应商交货时间，以优化库存管理\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("接收入库数据回传SRM，便于供应商确认收货情况\n                ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "content-left under-conter-right fl"
  }, [_c('img', {
    staticClass: "section3-img-left fl",
    attrs: {
      "src": require("../../assets/img/purchaseCoordination/peitu2-2.png"),
      "alt": "规范送货流程"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination-section3 purchase-coordination-section3-3"
  }, [_c('div', {
    staticClass: "section3-region"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("账单自动生成，对账准确高效，透明可查")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-content"
  }, [_c('ul', {
    staticClass: "content-detail clearfix"
  }, [_c('li', {
    staticClass: "content-left fl"
  }, [_c('img', {
    staticClass: "section3-img-left fr",
    attrs: {
      "src": require("../../assets/img/purchaseCoordination/peitu3-2.png"),
      "alt": "账单自动生成，对账准确高效，透明可查"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "content-right fl"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("基于ERP入库数据账单自动生成，准确高效，发票审批\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("一键导入ERP，对账准确，减轻财务人员繁琐的发票录入工作，"), _c('br'), _vm._v("\n                    订单、送货单、入库单、发票数据高度统一\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("无需结算单，采购价格透明可查，付款回传，方便供应商查看"), _c('br'), _vm._v("\n                    ERP的发票情况及付款情况\n              ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination-section3 purchase-coordination-section3-4"
  }, [_c('div', {
    staticClass: "section3-region"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("质量问题闭环管理，追踪每一次质量事件")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-content"
  }, [_c('ul', {
    staticClass: "content-detail clearfix section3-under"
  }, [_c('li', {
    staticClass: "content-right fl"
  }, [_c('div', {
    staticClass: "under-conter-left fr"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail4-bar"
  }), _vm._v("8D：根据质检结果可直接创建8D（或手工创建），由供应商及时"), _c('br'), _vm._v("\n                      反馈问题原因并提交临时&永久解决措施\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail4-bar"
  }), _vm._v("索赔：根据质检结果/8D可发布索赔单，将每一笔索赔追溯到原始"), _c('br'), _vm._v("\n                      订单，全流程清晰可查询\n                ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "content-left under-conter-right fl"
  }, [_c('img', {
    staticClass: "section3-img-left fl",
    attrs: {
      "src": require("../../assets/img/purchaseCoordination/peitu4-2.png"),
      "alt": "质量问题闭环管理，追踪每一次质量事件"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-coordination-section3 purchase-coordination-section3-5"
  }, [_c('div', {
    staticClass: "section3-region"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("寄售库存协同，供应商补货更及时")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-content"
  }, [_c('ul', {
    staticClass: "content-detail clearfix"
  }, [_c('li', {
    staticClass: "content-left fl"
  }, [_c('img', {
    staticClass: "section3-img-left fr",
    attrs: {
      "src": require("../../assets/img/purchaseCoordination/peitu5-2.png"),
      "alt": "寄售库存协同，供应商补货更及时"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "content-right fl"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("采供双方实时掌握备库情况和消耗记录、基于安全库存控制供"), _c('br'), _vm._v("\n                    应商发运\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("获取库存的预警标志至SRM，自动触发补货相关提醒\n              ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b3faca2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/purchaseCoordination.vue
// module id = 594
// module chunks = 12